var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.25 5.5H10.625V4.25C10.625 2.525 9.225 1.125 7.5 1.125C5.775 1.125 4.375 2.525 4.375 4.25V5.5H3.75C3.0625 5.5 2.5 6.0625 2.5 6.75V13C2.5 13.6875 3.0625 14.25 3.75 14.25H11.25C11.9375 14.25 12.5 13.6875 12.5 13V6.75C12.5 6.0625 11.9375 5.5 11.25 5.5ZM7.5 11.125C6.8125 11.125 6.25 10.5625 6.25 9.875C6.25 9.1875 6.8125 8.625 7.5 8.625C8.1875 8.625 8.75 9.1875 8.75 9.875C8.75 10.5625 8.1875 11.125 7.5 11.125ZM5.625 5.5V4.25C5.625 3.2125 6.4625 2.375 7.5 2.375C8.5375 2.375 9.375 3.2125 9.375 4.25V5.5H5.625Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcLock);
export default __webpack_public_path__ + "static/media/ic-lock.b17b15f4dd8f19af92d3b6ef404e36c3.svg";
export { ForwardRef as ReactComponent };